// extracted by mini-css-extract-plugin
module.exports = {"comboBox":"LanguageCombobox_comboBox__e8jY3","withoutBorder":"LanguageCombobox_withoutBorder___SQ7W","withBorder":"LanguageCombobox_withBorder__h_Kje"};